export default "__VITE_PUBLIC_ASSET__c3029a56__"